import React, { useEffect, useState } from 'react';
import { SignInButton } from '@clerk/clerk-react';

const DISMISSED_KEY = 'ni_guest_popup_dismissed';

export default function GuestDevicePopup() {
  const [state, setState] = useState('hidden'); // 'hidden' | 'modal' | 'banner'

  useEffect(() => {
    if (sessionStorage.getItem(DISMISSED_KEY)) {
      setState('banner');
      return;
    }
    const t = setTimeout(() => setState('modal'), 400);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, '1');
    setState('banner');
  };

  if (state === 'hidden') return null;

  if (state === 'banner') {
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9000,
        background: 'rgba(185, 28, 28, 0.15)',
        borderBottom: '1px solid rgba(220, 38, 38, 0.35)',
        padding: '0.45rem 1.25rem',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem',
        backdropFilter: 'blur(6px)'
      }}>
        <span style={{ color: '#fca5a5', fontSize: '0.82rem' }}>
          You're viewing limited device info —
        </span>
        <SignInButton mode="modal">
          <button style={{
            background: 'none', border: 'none', color: '#f87171',
            cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600,
            textDecoration: 'underline', padding: 0
          }}>
            Sign in for full access
          </button>
        </SignInButton>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: 'rgba(0,0,0,0.78)',
      backdropFilter: 'blur(5px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1.5rem',
      animation: 'guestFadeIn 0.2s ease'
    }}>
      <style>{`
        @keyframes guestFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes guestSlideUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div style={{
        background: '#111b16',
        border: '1px solid rgba(70,187,137,0.22)',
        borderRadius: '16px',
        padding: '2.5rem 2rem',
        maxWidth: '420px', width: '100%',
        display: 'flex', flexDirection: 'column',
        gap: '1.25rem', alignItems: 'center', textAlign: 'center',
        boxShadow: '0 28px 72px rgba(0,0,0,0.65)',
        animation: 'guestSlideUp 0.28s ease'
      }}>
        <img
          src="/wave-configurator-app/inspiration/Horizontal logo SVG/SVG/North-Invent-neg-green-Long.svg"
          alt="North Invent"
          style={{ height: '26px', width: 'auto' }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
          <h2 style={{ margin: 0, color: '#f9fafb', fontSize: '1.25rem', fontWeight: 700 }}>
            You're viewing limited device info
          </h2>
          <p style={{ color: '#9ca3af', margin: 0, lineHeight: 1.65, fontSize: '0.9rem' }}>
            Sign in to view warranty status, service history, and RMA cases.
            Claim this device to unlock an extra month of warranty for your whole team.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', width: '100%' }}>
          <SignInButton mode="modal">
            <button
              className="ni-button ni-button--primary"
              style={{ width: '100%', fontSize: '1rem', padding: '0.7rem 1.5rem' }}
              onClick={dismiss}
            >
              Sign in
            </button>
          </SignInButton>
          <button
            className="ni-button ni-button--ghost"
            style={{ width: '100%', fontSize: '0.88rem', padding: '0.6rem 1.5rem' }}
            onClick={dismiss}
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
